module.exports = __webpack_public_path__ + "img/dianhua.2e37c9dd.svg";